import SliderWithInput from '../../SliderWithInput';

interface LegendSizeControlsProps {
  isCalendarOrHeatmap: boolean;
  pieceWise?: boolean;
  orientation: string;
  itemGap: number;
  width: number;
  height: number;
  symbolWidth?: number;
  symbolHeight?: number;
  onItemGapChange: (value: number) => void;
  onWidthChange: (value: number) => void;
  onHeightChange: (value: number) => void;
  onSymbolWidthChange?: (value: number) => void;
  onSymbolHeightChange?: (value: number) => void;
  iconColor?: string;
}

export const LegendSizeControls = ({
  isCalendarOrHeatmap,
  pieceWise,
  orientation,
  itemGap,
  width,
  height,
  symbolWidth,
  symbolHeight,
  onItemGapChange,
  onWidthChange,
  onHeightChange,
  onSymbolWidthChange,
  onSymbolHeightChange,
  iconColor,
}: LegendSizeControlsProps) => {
  const itemWidthMinMax = { min: 5, max: 200, step: 1 };
  const itemHeightMinMax = { min: 5, max: 200, step: 1 };
  const itemSpacingMinMax = { min: 0, max: 60, step: 1 };

  return (
    <>
      {isCalendarOrHeatmap ? (
        <>
          {pieceWise && (
            <>
              <div
                className="optionDescription"
                style={{ color: iconColor ? iconColor : '#404040' }}
              >
                Item Gap
              </div>
              <SliderWithInput
                sliderValue={itemGap}
                sliderMinMax={itemSpacingMinMax}
                percent={true}
                changeValue={onItemGapChange}
              />
            </>
          )}
          <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
            {!pieceWise && orientation === 'vertical' ? 'Height' : 'Width'}
          </div>
          <SliderWithInput
            sliderValue={width}
            sliderMinMax={itemWidthMinMax}
            percent={true}
            changeValue={onWidthChange}
          />
          <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
            {!pieceWise && orientation === 'vertical' ? 'Width' : 'Height'}
          </div>
          <SliderWithInput
            sliderValue={height}
            sliderMinMax={itemHeightMinMax}
            percent={true}
            changeValue={onHeightChange}
          />
        </>
      ) : (
        <>
          <div
            className="optionDescription"
            style={{
              paddingTop: '0',
              color: iconColor ? iconColor : '#404040',
            }}
          >
            Item Gap
          </div>
          <SliderWithInput
            sliderValue={itemGap}
            sliderMinMax={itemSpacingMinMax}
            changeValue={onItemGapChange}
          />
          <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
            Width
          </div>
          <SliderWithInput
            sliderValue={symbolWidth || 0}
            sliderMinMax={itemWidthMinMax}
            percent={false}
            changeValue={onSymbolWidthChange || (() => {})}
          />
          <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
            Height
          </div>
          <SliderWithInput
            sliderValue={symbolHeight || 0}
            sliderMinMax={itemHeightMinMax}
            percent={false}
            changeValue={onSymbolHeightChange || (() => {})}
          />
        </>
      )}
    </>
  );
};
